<template>
  <div>
    <a-select
      show-search
      v-model:value="cityNameInfo"
      style="width: 100%"
      :show-arrow="false"
      :not-found-content="null"
      :filter-option='false'
      @search="handleSearch"
      @change="handleChange"
      @focus="handleFocus(true)"
      :ref='torefs'
      @blur='handleBlur'
      :disabled="disabled"
    > 
      <template v-for="(item,index) in filterData" :key="index" >
        <a-select-option  :value="item.name">
          {{ item.name }} 
        </a-select-option>
      </template>
    </a-select>
    <div class="citiesCard" v-show="showCard" @click='tabClick'>
      <div class="title">支持中文/拼音/简拼输入</div>
      <div>
        <a-tabs
          @tabClick='tabClick'
        >
          <a-tab-pane key="1" tab="热门">
            <div class="content">
              <a-row class="city-list">
                <span
                  class="city-item hover_item"
                  v-for="(item, index) in cities.hot"
                  :key="index"
                  @click="confirmCity(item)"
                >   
                  {{ item.name }}
                </span>
              </a-row>
            </div>
          </a-tab-pane>
          <a-tab-pane
            v-for="(item, index) in filterArr"
            :key="index + 2"
            :tab="item"
          >
            <div class="content">
              <a-row class="city-list" v-for="i in item" :key="i">
                <a-col :span="2" class="city-left" v-if="cities[i].length > 0">
                  <span class="city-item">
                    {{ i }}
                  </span>
                </a-col>
                <a-col :span="22" class="city-right">
                  <span
                    class="city-item hover_item"
                    v-for="(city, index) in cities[i]"
                    :key="index"
                    @click="confirmCity(city)"
                    :title="city.name"
                  >
                    {{ city.name }}
                  </span>
                </a-col>
              </a-row>
            </div>
          </a-tab-pane>
        </a-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, watch } from 'vue'
import commonApi from '@axios/common'
export default {
  componentname: "selectCity",
  props: {
    cityNameInfo: String,
    disabled: {
      type : Boolean,
      default:false
    },
  },
  setup (props, context) {
    let isFrom = ref(false)
    watch(isFrom, () => {
      console.log(isFrom)
    })

    let refList = [];

    const torefs = (el) => {
      refList.push(el)
    }

    let cityName = ref('')
    cityName.value = props.cityNameInfo
    let cities = ref({})
    let allCitiesData = ref([])
    let filterData = ref([])
    let showCard = ref(false)
    let changeCity = ref(true)
    let filterArr = ref([])
    filterArr.value = ['ABCD', 'EFGH', 'JKLM', 'NOPQRS', 'TUVWX', 'YZ']

    // 获取城市
    const getAllStation = () => {
      commonApi.getAllStation().then((res) => {
        let newObj = {}
        res.forEach(element => {
          newObj[element.letter] = element.stationBos
          newObj[element.letter] = element.stationBos
          newObj.hot = [
            {
              name: "上海",
            },
            {
              name: "北京",
            },
            {
              name: "杭州",
            },
            {
              name: "广州",
            },
            {
              name: "重庆",
            },
            {
              name: "天津",
            },
            {
              name: "成都",
            },
            {
              name: "长沙",
            },

          ]
        })
        allCitiesData.value = allCitiesData.value.concat(
          newObj.A,
          newObj.B,
          newObj.C,
          newObj.D,
          newObj.E,
          newObj.F,
          newObj.G,
          newObj.H,
          newObj.J,
          newObj.K,
          newObj.L,
          newObj.M,
          newObj.N,
          newObj.P,
          newObj.Q,
          newObj.R,
          newObj.S,
          newObj.T,
          newObj.W,
          newObj.X,
          newObj.Y,
          newObj.Z
        )
        cities.value = newObj
        // console.log(cities.value)
      })
    }
    getAllStation()
  

    const handleSearch = (queryString) => {
      var CitiesList = allCitiesData.value
   
      var results = queryString ? CitiesList.filter(createStateFilter(queryString)) : CitiesList

      let newresults = results.splice(0,20);
   
      filterData.value = newresults

      showCard.value = false
    }
    const createStateFilter = (queryString) => {
      var reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g')
      if (reg.test(queryString)) {
        return (state) => {
          return (state.name.indexOf(queryString) !== -1)
        }
      } else {
        return (state) => {
          return (state.name.toLowerCase().indexOf(queryString.toLowerCase()) !== -1 || state.pinyin.toLowerCase().indexOf(queryString.toLowerCase()) !== -1 || state.pinyinSort.toLowerCase().indexOf(queryString.toLowerCase()) !== -1 || state.code.toLowerCase().indexOf(queryString.toLowerCase()) !== -1)
        }
      }
    }
    const handleChange = (item) => {
      filterData.value = []

      cityName.value = item
      context.emit('selectCity', item)
      showCard.value = false
    }

    const handleFocus = (value) => {
      changeCity.value = value
      showCard.value = true
    }

    const confirmCity = (item) => {

      cityName.value = item.name
      context.emit('selectCity', item.name)
      showCard.value = false
    }

    const handleBlur = () => {
      
      showCard.value = false
    }

    const tabClick = () => {
        refList[0].focus();
    }

    return {
      torefs,
      tabClick,
      cityName,
      handleBlur,
      allCitiesData,
      cities,
      filterData,
      filterArr,
      handleSearch,
      handleChange,
      handleFocus,
      showCard,
      confirmCity
    }
  }
}
</script>
<style  rel="stylesheet/scss" lang="scss" scoped>
.hover_item:hover{
  background: #0D6DBF!important;
  color:#fff!important;
}
.citiesCard ::v-deep(.ant-tabs-nav-scroll){
  background: none!important;
}
.citiesCard {
  width: 450px;
  height: 300px;
  padding: 15px;
  font-size: 12px;
  text-align: left;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #dadce0;
  position: absolute;
  z-index: 99;
  .title {
    line-height: 20px;
  }
  .content {
    height: 200px;
    overflow-y: scroll;
    .city-list {
      padding: 0 10px;
      .city-item {
        display: inline-block;
        padding:0px 5px;
        
        border-radius:3px;
        min-width: 57px;
        height: 22px;
        margin: 2px 12px 2px 0;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        line-height: 22px;
        color: #333;
        cursor: pointer;
      }
    }
  }
}
</style>
